import { Box, Divider, Grid } from "@mui/material";
import React, { PropsWithChildren } from "react";
import BaseLayout from "../base/base_layout";
import Navbar from "../../components/navbar/navbar";
import { MAIN_THEME_COLOR } from "../../providers/theme/colors/colors";
import Footer from "../../components/footer/footer";
import Breadcrumb from "../../components/breadcrumbs/breadcrubm";
import { useLocation } from "react-router-dom";

export default function MainLayout({ children }: PropsWithChildren<{}>) {
  const { pathname } = useLocation();
  console.log(pathname);

  return (
    <BaseLayout>
      <Grid container justifyContent={"center"}>
        <Box
          sx={{
            display: "flex",
            position: "fixed",
            top: 0,
            width: "100%",
            zIndex: 9999,
            minHeight: { xs: 80, md: 90 },
            height: "auto",
            backgroundColor: "#ffffff",
          }}
          borderBottom={`1px solid ${MAIN_THEME_COLOR}`}
        >
          <Grid md={1} lg={1} />
          <Grid item md={10} lg={10} sm={12}>
            <Navbar />
          </Grid>
          <Grid md={1} lg={1} />
        </Box>
        <Grid md={1} lg={1} />
        <Grid
          item
          md={pathname?.split("/")?.includes("surveyResponse") ? 12 : 10}
          lg={10}
          sm={pathname?.split("/")?.includes("surveyResponse") ? 12 : 10}
          xs={pathname?.split("/")?.includes("surveyResponse") ? 12 : 10}
          mt={12}
        >
          <Breadcrumb />
          {children}
        </Grid>
        <Grid md={1} lg={1} />
        <Grid item md={12} lg={12} sm={12} xs={12}>
          <Footer />
        </Grid>
      </Grid>
    </BaseLayout>
  );
}
